import {
    Container,
    Row,
    Col
} from "reactstrap";

import {
    FiTrendingUp,
    FiUsers,
    FiBookOpen
} from "react-icons/fi";

import "./CourseHighlights.css";

const highlightIcons = [
    FiTrendingUp,
    FiUsers,
    FiBookOpen
];

function CourseHighlights({ courseName, highlights }) {

    return (
        <section className="course-highlights">

            <Container>

                <div className="course-highlights-header">

                    {/* <span className="course-section-label">
                        CAREER ADVANTAGES
                    </span> */}

                    <h2>
                        Career Advantages
                        {/* Why Learn {courseName}? */}
                    </h2>

                    <p>
                        Build specialized skills that can help you
                        move beyond traditional CAD design roles.
                    </p>

                </div>


                <Row className="g-4">

                    {highlights.map((item, index) => {

                        const Icon = highlightIcons[index];

                        return (
                            <Col
                                lg="4"
                                md="6"
                                sm="12"
                                key={item.title}
                            >

                                <div className="course-highlight-card">

                                    <div className="course-highlight-icon">

                                        <Icon />

                                    </div>


                                    <h3>
                                        {item.title}
                                    </h3>


                                    <p>
                                        {item.description}
                                    </p>


                                    <div className="course-highlight-number">
                                        0{index + 1}
                                    </div>

                                </div>

                            </Col>
                        );

                    })}

                </Row>

            </Container>

        </section>
    );
}

export default CourseHighlights;